<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span> {{ info.className }} 签到详情</span>
		    <span> 授课老师: {{ info.classStudentNum }}</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="queryParams" label-width="">
        <el-form-item label="学年学期">
           <el-select
              v-model="queryParams.value1"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in list1"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="上课日期">
          <el-date-picker 
				   	v-model="queryParams.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
				   	:picker-options="pickerOptions">
			  </el-date-picker>
        </el-form-item>
        <el-form-item label="星级">
          <el-select v-model="queryParams.star" clearable placeholder="选择星级" class="label">
            <el-option v-for="item in starList" :key="item.id" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="searchFun"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="studentName" label="学生姓名" align="center">
          </el-table-column>
          <el-table-column prop="className" label="应出勤次数" align="center">
          </el-table-column>
          <el-table-column prop="signTime" label="迟到次数" align="center">
          </el-table-column>
		      <el-table-column prop="a" label="请假次数" align="center">
          </el-table-column>
          <el-table-column prop="b" label="实际出勤次数" align="center">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      queryParams: {
		    value1:"",
        time: "",
        star: "",
        studentName: "",
      },
      tableData: [
        // {studentName:'衡锦舒',className:'25', signTime:'3',a:'3',b:'22',},
        // {studentName:'范月园',className:'27', signTime:'2',a:'3',b:'24',},
        // {studentName:'杭上慧',className:'22', signTime:'2',a:'2',b:'20',},
        // {studentName:'颜婕伊',className:'29', signTime:'2',a:'2',b:'27',},
        // {studentName:'邬金无',className:'29', signTime:'3',a:'1',b:'28',},
        // {studentName:'林雁雁',className:'13', signTime:'1',a:'1',b:'12',},
        // {studentName:'晋芸姣',className:'27', signTime:'3',a:'2',b:'25',},
        // {studentName:'符薇歌',className:'18', signTime:'3',a:'2',b:'16',},
        // {studentName:'安凤昭',className:'10', signTime:'2',a:'2',b:'8',},
        // {studentName:'耿眉荔',className:'19', signTime:'3',a:'3',b:'16',},
      ],
	    starList: [
				{id:'star1',label:'1星'},
				{id:'star2',label:'2星'},
				{id:'star3',label:'3星'},
				{id:'star4',label:'4星'},
				{id:'star5',label:'5星'},
				{id:'star6',label:'6星'},
				{id:'star7',label:'7星'},
			],
	    list1:[
				{id:"1",label:"2021~2022年度下学期	  ",  value:"1"},
				{id:"2",label:"2021~2022年度上学期	 ",value:"2"},
				{id:"3",label:"2020~2021年度下学期	 ",  value:"3"},
				{id:"4",label:"2020~2021年度上学期	 ",value:"4"},
				{id:"5",label:"2019~2020年度下学期	 ",  value:"5"},
				{id:"6",label:"2019~2020年度上学期	  ",value:"6"},
			],
      campusList: [
        {id:'campus1',label:'驻马店实验小学主校区'},
      ],
      gradeList: [
        {id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
      ],
	    pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
    };
  },
  watch: {
    info: {
      handler: function () {
        // this.getDataList();
      },
      deep: true,
    },
  },
  created() {
    // this.getDataList();
    // if(this.school_info.length>0){
    //     this.campusList = this.school_info.slice();
    // }
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: "",
        gradeId: this.queryParams.gradeId,
        campusId: this.queryParams.campusId,
        courseName: "",
        courseApplyId: this.info.courseApplyId,
        studentName: this.queryParams.studentName,
        orgId:sessionStorage.getItem('orgId'),
        platformCode: sessionStorage.getItem('platformCode'),
        page: this.pageNum,
        limit: this.pageSize,
      };
      var { data, code } = await api.handleStudentDetails(params);
      console.log("获取列表数据---", data, code);
      if (code == "0") {
        this.tableData = data.list;
        this.totalPage = data.total;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 200px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
